<template>
  <main-content-layout title="실적 TOP 5" img-src="member_status_icon.png">
    <template v-slot:button>
      <div class="carousel-buttons-layout">
        <v-img
            class="carousel-button"
            :src="require(`@/assets/images/icons/carousels_left_icon.png`)"
            @click="prevCategory"
        />
        <v-img
            class="carousel-button"
            :src="require(`@/assets/images/icons/carousels_right_icon.png`)"
            @click="nextCategory"
        />
      </div>
    </template>
    <template v-slot:content>
      <div class="top-rank-header">
        <div class="top-rank-title-layout" v-for="(name, index) in topRankTitleList" :key="index + '_title'" v-show="index === currentTopRankIndex">
          {{ name }}
        </div>
        <div class="select-input-container">
          <v-select
            class="select-input"
            v-model="gubunType"
            :items="gubunTypeList"
            item-text="text"
            item-value="value"
            outlined hide-details dense
            background-color="white"
          />
          <v-select
            class="select-input"
            v-model="dateType"
            :items="dateTypeList"
            item-text="text"
            item-value="value"
            outlined hide-details dense
            background-color="white"
          />
<!--          <v-tabs v-model="gubunTabs">-->
<!--            <v-tab style="background-color: #f8f8f8">일반대출</v-tab>-->
<!--            <v-tab style="background-color: #f8f8f8">집단대출</v-tab>-->
<!--          </v-tabs>-->
<!--          <v-tabs v-model="dateTabs">-->
<!--            <v-tab style="background-color: #f8f8f8">당월</v-tab>-->
<!--            <v-tab style="background-color: #f8f8f8">당해</v-tab>-->
<!--          </v-tabs>-->
        </div>
      </div>
      <div class="top-rank-list-layout">
        <div class="top-rank-list" v-for="(item, index) in topRankList" :key="index">
          <v-row class="top-rank-layout">
            <v-col class="top-rank" cols="2">{{ item.rank }}</v-col>
            <v-col class="top-rank" cols="3">{{ item.orgNm + "팀" }}</v-col>
            <v-col class="top-rank" cols="4">{{ item.memberNm }}</v-col>
            <v-col class="top-rank" cols="3" v-show="currentTopRankIndex !== 2">{{ setTotalItem(item.total) }}</v-col>
          </v-row>
        </div>
      </div>
    </template>
  </main-content-layout>
</template>
<script>
import MainContentLayout from "@/pages/Main/components/layout/MainContentLayout.vue";
import {axiosInstance} from "@/util/AxiosModule";
import _ from "lodash";

export default {
  name: "TopRanking",
  components: {MainContentLayout},
  data() {
    return {
      topRankTitleList: ["건수", "대출실적", "수수료"],
      topRankData: {},
      currentTopRankIndex: 0,
      gubunType: "",
      gubunTypeList: [
        { text: "전체", value: "" },
        { text: "일반", value: "1" },
        { text: "집단", value: "6" }
      ],
      dateType: "month",
      dateTypeList: [
        { text: "당월", value: "month" },
        { text: "당해", value: "year" }
      ]
    }
  },
  computed: {
    topRankList() {
      const typeMap = {
        0: "Cnt",
        1: "Amt",
        2: "Fee"
      };

      const prefix = this.dateType === "year" ? "yearTop" : "top";
      const suffix = this.gubunType || "";
      const type = typeMap[this.currentTopRankIndex];

      const key = `${prefix}${type}${suffix}`;

      const target = this.topRankData[key] || [];

      return target.map((item, index) => ({
            ...item,
            rank: index + 1
          }));
    }
  },
  mounted() {
    this.getTopRanking();
  },
  methods: {
    async getTopRanking() {
      try {
        const { data } = await axiosInstance.get("/private/performance/top-rank", {
          params: {
            cnt: 5
          }
        });
        if (_.isEmpty(data)) {
          this.topRankData = {};
        } else {
          this.topRankData = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    prevCategory() {
      if (this.currentTopRankIndex === 0) {
        this.currentTopRankIndex = this.topRankTitleList.length - 1;
      } else {
        this.currentTopRankIndex -= 1;
      }
    },
    nextCategory() {
      if (this.currentTopRankIndex === this.topRankTitleList.length - 1) {
        this.currentTopRankIndex = 0;
      } else {
        this.currentTopRankIndex += 1;
      }
    },
    setTotalItem(item) {
      if (this.currentTopRankIndex === 0) {
        return item + "건";
      }
      if (this.currentTopRankIndex === 1) {
        if (item.toString().length > 8) {
          return this.formatAmt(item) + "억원";
        } else if (5 <= item.toString().length <= 8) {
          return this.formatAmt(item) + "만원";
        } else if (item.toString().length === 4) {
          return this.formatAmt(item) + "천원";
        } else if (item.toString().length === 3) {
          return this.formatAmt(item) + "백원";
        } else if (item.toString().length === 2) {
          return this.formatAmt(item) + "십원";
        } else if (item.toString().length < 2) {
          return this.formatAmt(item) + "원";
        }
      }
      return null;
    },
    formatAmt(num) {
      const str = num.toString();
      const front = str.slice(0, -8);
      return front.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel-buttons-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  .carousel-button {
    margin: 0 5px;
    width: min(6vw, 30px);
  }
  .carousel-button:hover {
    cursor: pointer;
  }
}
.top-rank-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .top-rank-title-layout {
    font-size: min(4vw, 24px);
    font-weight: bold;
    margin-bottom: 5px;
  }
  .select-input-container {
    display: flex;
    justify-content: center;
    align-items: center;
    .select-input {
      width: min(22vw, 100px);
    }
    .select-input:first-child {
      margin-right: 5px;
    }
  }
}
.top-rank-list-layout {
  width: 100%;
  height: 13vh;
  overflow-y: auto;
  .top-rank-list {
    margin: 5px 0;
    border-radius: 5px;
    font-size: min(5vw, 10px);
    background-color: #ffffff;
    .top-rank-layout {
      margin: 0;
      .top-rank {
        text-align: center;
        font-size: 2.8vw;
        font-weight: bold;
      }
      .top-rank:nth-child(1),
      .top-rank:nth-child(2) {
        text-align: left;
      }
      .top-rank:nth-last-child(1) {
        text-align: right;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .top-rank-list-layout {
    height: 22vh;
    .top-rank-list {
      margin: 10px 0;
      .top-rank-layout {
        .top-rank {
          font-size: 14px;
        }
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .top-rank-list-layout {
    height: 100%;
    .top-rank-list {
      margin: 15px 0;
      .top-rank-layout {
        .top-rank {
          font-size: 15px;
        }
      }
    }
  }
}
</style>